import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';
import { NavLink } from 'react-router-dom';

const WellCrafting = () => {
    const [loading, setLoading] = useState(true);
    const [homepages, setHome] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, [homepages]);

    useEffect(() => {
        const fetchTrendingStyle = async () => {
            try {
                const response = await axiosInstance.get('/cms-page/home');
                if (response.data.success) {
                    console.log(response.data.cmspage);
                    setHome(response.data.cmspage || []);
                }else{
                    setError('Failed to load categories');
                }
            } catch (error) {
                console.error("Error fetching trending styles:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchTrendingStyle();
    }, []);


    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }
    
    return (
        <section className="no-top jarallax">
            <div className="de-gradient-edge-top"></div>
            <img src="assets/images/background/1.jpg" className="jarallax-img" alt="" />
            <div className="container relative z1000">
                {homepages.map((item, index) => {
                    const firstImageUrl =item.profile_img_url[0] || '';
                    console.log('First Image URL:', item.profile_img_url[0]);
    
                    return (
                        <div className="row align-items-center" key={index}>
                            <div className="col-lg-6 jarallax" data-jarallax-element={item.count}>
                                <img src={firstImageUrl} className="img-fluid wow fadeInRight" alt="" />
                            </div>
                            <div className="col-lg-6 jarallax" data-jarallax-element="-60">
                                <h2 className="wow fadeInRight" data-wow-delay=".3s">
                                  {item.section_title || 'We’ll Crafting'}
                                    {/* We’ll Crafting <span className="id-color">Confidence</span> Through Sharp Style */}
                                </h2>
                                <p className="wow fadeInRight" data-wow-delay=".4s">
                                    <div
                                        className="vision-mission-description"
                                        dangerouslySetInnerHTML={{ __html: item.description || 'Test' }}
                                    />
                                </p>
                                <NavLink to="/book-now" className="btn-main wow fadeInRight" data-wow-delay=".5s">
                                 {item.button_label || 'Book Now'}
                                </NavLink>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="de-gradient-edge-bottom"></div>
        </section>
    );
    
}

export default WellCrafting;
